document.addEventListener("alpine:init", () => {
    Alpine.data("loadMorePosts", (data) => ({
        posts: [],
        paged: 1,
        hasMore: true,
        noResults: false,
        postType: data.postType || '',
        postsPerPage: data.postsPerPage || 12,
        totalPosts: 0,
        searchQuery: '',
        categoryFilter: 'all_categories',
        tagFilter: 'all_tags',
        regionFilter: 'all_regions',
        districtFilter: 'all_districts',
        projectFilter: 'all_projects',
        initialCategories: data.initialCategories || '',
        initialTags: data.initialTags || '',
        initialRegions: data.initialRegions || '',
        initialDistricts: data.initialDistricts || '',
        initialProjects: data.initialProjects || '',
        bgColor: data.bgColor || '#ffffff',
        textColor: data.textColor || '#0D0E11',

        async fetchPosts(reset = false) {
            if (reset) {
                this.paged = 1;
                this.posts = [];
                this.hasMore = true;
                this.noResults = false;
            }

            let formData = new FormData();
            formData.append("action", "load_more_posts");
            formData.append("paged", this.paged);
            formData.append("post_type", this.postType);
            formData.append("posts_per_page", this.postsPerPage);
            formData.append("search", this.searchQuery);
            formData.append("category", this.categoryFilter);
            formData.append("tag", this.tagFilter);
            formData.append("region", this.regionFilter);
            formData.append("district", this.districtFilter);
            formData.append("project", this.projectFilter);
            formData.append("initial_categories", this.initialCategories);
            formData.append("initial_tags", this.initialTags);
            formData.append("initial_regions", this.initialRegions);
            formData.append("initial_districts", this.initialDistricts);
            formData.append("initial_projects", this.initialProjects);
            formData.append("bg_color", this.bgColor);
            formData.append("text_color", this.textColor);

            let response = await fetch(appAjax.ajax_url, {
                method: "POST",
                credentials: 'same-origin',
                body: formData,
            });

            let data = await response.json();

            if (reset || this.totalPosts === 0) {
                this.totalPosts = data.total_posts;
            }

            if (data.posts.length === 0) {
                this.hasMore = false;
                this.noResults = this.paged === 1;
            } else {
                this.posts.push(...data.posts.map(post => ({
                    id: post.id,
                    post_type: post.post_type,
                    title: post.title,
                    information: post.information,
                    link_text: post.link_text,
                    excerpt: post.excerpt,
                    url: post.url,
                    alt_url: post.alt_url,
                    thumbnail: post.thumbnail.replace(/\bauto,\s?/g, ''),
                    tag: post.tag,
                    price: post.price,
                    price_per: post.price_per,
                    start_date: post.start_date,
                    end_date: post.end_date,
                    time: post.time,
                    published_date: post.published_date,
                    unpublish_date: post.unpublish_date,
                    display_day: post.display_day,
                    display_month: post.display_month,
                    address: post.address,
                    postal_code: post.postal_code,
                    city: post.city,
                    bg_color: post.bg_color,
                    text_color: post.text_color,
                    tag_classes: post.tag_classes,
                    headline_classes: post.headline_classes,
                    special_tag_color: post.special_tag_color,
                    special_headine_color: post.special_headine_color,
                    region: post.region,
                })));

                this.paged++;
                this.noResults = false;

                if (this.posts.length >= this.totalPosts) {
                    this.hasMore = false;
                }
            }
        },

        loadMore() {
            this.fetchPosts();
        },

        filterPosts() {
            this.fetchPosts(true);
        },

        setCategoryFilter(category) {
            this.categoryFilter = category;
            this.filterPosts();
        },

        setTagFilter(tag) {
            this.tagFilter = tag;
            this.filterPosts();
        },

        setRegionFilter(region) {
            this.regionFilter = region;
            this.filterPosts();
        },

        setDistrictFilter(district) {
            this.districtFilter = district;
            this.filterPosts();
        },

        setProjectFilter(project) {
            this.projectFilter = project;
            this.filterPosts();
        },

        init() {
            this.loadMore();
        }
    }));
});

//# sourceMappingURL=load-more-posts.js.map
